import { useCallback, useRef, useState } from "react";
import { UploadCloud, FileCode2, X } from "lucide-react";

export const HexDropzone = ({ file, onFileSelected, onClear, disabled }) => {
    const [dragOver, setDragOver] = useState(false);
    const inputRef = useRef(null);

    const handleFiles = useCallback(
        (files) => {
            if (!files || !files.length) return;
            const f = files[0];
            if (!f.name.toLowerCase().endsWith(".hex")) {
                onFileSelected(null, "File must have .hex extension");
                return;
            }
            onFileSelected(f, null);
        },
        [onFileSelected],
    );

    const onDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        if (disabled) return;
        handleFiles(e.dataTransfer.files);
    };

    if (file) {
        return (
            <div
                data-testid="hex-file-selected"
                className="border border-[#27272a] bg-[#0d0d0e] p-5 flex items-start gap-4"
            >
                <div className="w-10 h-10 flex items-center justify-center bg-[#10B981]/10 border border-[#10B981]/40 shrink-0">
                    <FileCode2 className="w-5 h-5 text-[#10B981]" />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="text-sm font-mono text-[#ededed] truncate" title={file.name}>
                        {file.name}
                    </div>
                    <div className="text-xs font-mono text-[#a1a1aa] mt-1">
                        {file.size.toLocaleString()} bytes
                    </div>
                </div>
                {!disabled && (
                    <button
                        type="button"
                        data-testid="hex-file-clear"
                        onClick={onClear}
                        className="text-[#a1a1aa] hover:text-[#ef4444] transition-colors p-1"
                        aria-label="Remove file"
                    >
                        <X className="w-4 h-4" />
                    </button>
                )}
            </div>
        );
    }

    return (
        <>
            <input
                ref={inputRef}
                type="file"
                accept=".hex"
                className="hidden"
                data-testid="hex-file-input"
                onChange={(e) => handleFiles(e.target.files)}
                disabled={disabled}
            />
            <button
                type="button"
                data-testid="hex-file-dropzone"
                disabled={disabled}
                onClick={() => inputRef.current?.click()}
                onDragOver={(e) => {
                    e.preventDefault();
                    if (!disabled) setDragOver(true);
                }}
                onDragLeave={() => setDragOver(false)}
                onDrop={onDrop}
                className={`w-full border-2 border-dashed p-8 flex flex-col items-center justify-center text-center min-h-[160px] transition-all ${
                    disabled
                        ? "border-[#27272a] bg-[#0d0d0e] opacity-50 cursor-not-allowed"
                        : dragOver
                          ? "border-[#10B981] bg-[#10B981]/5"
                          : "border-[#27272a] bg-[#0d0d0e] hover:border-[#F59E0B] hover:bg-[#F59E0B]/5 cursor-pointer"
                }`}
            >
                <UploadCloud className="w-7 h-7 text-[#a1a1aa] mb-3" />
                <div className="text-sm text-[#ededed] font-medium">
                    Drop .hex file or click to browse
                </div>
                <div className="text-xs text-[#a1a1aa] font-mono mt-2">
                    Intel HEX firmware
                </div>
            </button>
        </>
    );
};
